/**
 * @file index.js
 * Exports all layout components.
 */

import ThinLayout from './ThinLayout/ThinLayout';
import DashboardLayout from './DashboardLayout/DashboardLayout';
import VREditorLayout from './VREditorLayout/VREditorLayout';
import Header from './Header/Header';
import Footer from './Footer/Footer';

export { ThinLayout, DashboardLayout, VREditorLayout, Header, Footer };



// WEBPACK FOOTER //
// ./src/layouts/index.js